import { render, staticRenderFns } from "./company-currency.vue?vue&type=template&id=15d65db6&scoped=true"
import script from "./company-currency.vue?vue&type=script&lang=js"
export * from "./company-currency.vue?vue&type=script&lang=js"
import style0 from "./company-currency.vue?vue&type=style&index=0&id=15d65db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d65db6",
  null
  
)

export default component.exports